import {useGetAndSet} from "./useGetAndSet";
import {createSetMovementFigureDataAction} from "../actions/dataActions";


export const useMovementFigureData = (params, dataFresh) => {
    return useGetAndSet("movementfigures", params, createSetMovementFigureDataAction, dataFresh)
}